import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ComponentsFactory from 'foundation/components-factory';

class QualEventItem extends React.Component {
    constructor(props) {
        super(props);
        this.rootRef = React.createRef();
    }

    componentDidMount() {
        ComponentsFactory.getInstance().init(this.rootRef.current);
    }

    componentWillUnmount() {
        ComponentsFactory.getInstance().destroy(this.rootRef.current);
    }

    render() {
        const sitecoreData = get(this.props, 'location.sitecoreData');

        if (!sitecoreData) return null;
        let isFirstLinkDefined = sitecoreData.link1 !== null && sitecoreData.link1 !== undefined;
        let isSecondLinkDefined = sitecoreData.link2 !== null && sitecoreData.link2 !== undefined;
        
        return (
            <li className="qual-events__cards-item">
                <div className="qual-events__cards-item-container">
                    <div className="qual-events__cards-item-bg">
                        <img
                            className="lazyload"
                            data-srcset={sitecoreData.overviewSrc}
                            alt=""
                            data-sizes="auto"
                        />
                    </div>
                    <div className="qual-events__cards-item-content-wrapper">
                        <div className="qual-events__cards-item-content">
                            <h2 className="qual-events__cards-item-title">{sitecoreData.name}</h2>
                            {
                                isFirstLinkDefined &&
                                <a href={sitecoreData.link1}
                                    className="qual-events__cards-item-link"
                                    data-dc-component="modal-spa-trigger"
                                    ref={this.rootRef}>
                                    {sitecoreData.firstLinkText}
                                </a>
                            }
                            {
                                isSecondLinkDefined &&
                                <a href={sitecoreData.link2}
                                    className="qual-events__cards-item-link"
                                    data-dc-component="modal-spa-trigger"
                                    ref={this.rootRef}>
                                    {sitecoreData.secondLinkText}
                                </a>
                            }
                            <a href={sitecoreData.pageUrl}
                                className="qual-events__cards-item-link"
                                data-dc-component="modal-spa-trigger"
                                ref={this.rootRef}>
                                View more
                            </a>
                        </div>
                    </div>
                </div>
            </li>
        );
    }
}

QualEventItem.propTypes = {
    location: PropTypes.object
};

export default QualEventItem;
